<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="declaratoria-dialog-title">
  <div class="dialog-icon" aria-hidden="true">
    <div class="icon-circle">
      <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
    </div>
  </div>

  <h2 id="declaratoria-dialog-title">Confirmación de declaratoria</h2>
  <p class="subtitle">
    Confirma que revisaste todas las preguntas con el cliente y que cumples con los requisitos para una venta responsable.
  </p>

  <div class="checkbox-wrapper">
    <app-sis-checkbox [(ngModel)]="accepted">
      Declaro que he leído, revisado y completado la información conforme a los requisitos establecidos.
    </app-sis-checkbox>
  </div>

  <div class="dialog-actions">
    <app-sis-button variant="secondary" (pressed)="close(true)">Cancelar</app-sis-button>
    <app-sis-button [disabled]="!accepted" (pressed)="close(false)">Continuar</app-sis-button>
  </div>
</div>
